module.exports = __webpack_public_path__ + "img/img-5542.1c79a054.png";